@for (link of links; track i; let i = $index) {
  <span class="td-wb-quote-link__item">
    <a [tdWbHref]="link.url"
       [translate]="link.title"></a>
    @if (i < links.length - 1) {
      <span [innerText]="' | ' "></span>
    }&nbsp;
    </span>
}

